import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import Env from '@ridango/core/env';
import { Area, AreaCode, NextButtonElement } from '@ridango/components/lib/purchase/purchase.model';
import { BaseComponent, TravelMedia } from '@ridango/core';
import { ProductCategoryAreaNameEnum } from '@ridango/core/lib/enums/product-category-area-name.enum';

@Component({
    selector: 'gl-purchase-v2-ticket-product-areas',
    templateUrl: './product-area.component.html'
})
export class ProductAreaComponent extends BaseComponent {
    @Input() selectedArea: Area;
    @Input() productAreas;
    @Input() selectedProductAreas: string[];
    @Input() selectedOption: TravelMedia;
    @Output() nextStep: EventEmitter<void> = new EventEmitter<void>();
    @Output() nextButtonElement = new EventEmitter<NextButtonElement>();
    @Output() errorEvent = new EventEmitter<string>();
    protected readonly ProductCategoryAreaNameEnum = ProductCategoryAreaNameEnum;
    AreaCode = AreaCode;

    constructor(@Inject('ENV') public env: Env) {
        super();
    }

    handleNextButtonElement($event) {
        this.nextButtonElement.emit($event);
    }

    handleErrorEvent(message?: string) {
        this.errorEvent.emit(message);
    }

    handleNextStep() {
        this.nextStep.emit();
    }
}
